// lib
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import queryString from "query-string";
// src
import { fetchBackToken } from "actions/user/thunks";

export default () => {
  const isLogged = useSelector((state) => state.user.isLogged);
  if (isLogged) return <Redirect to="/" />;

  const dispatch = useDispatch();
  const { search } = useLocation();
  const { ticket } = queryString.parse(search);
  if (ticket) dispatch(fetchBackToken(ticket));

  return <div />;
};
